// Note: guards a step that talks to IndexedDB. Dexie waits indefinitely when the database cannot be
// opened - another connection blocking an upgrade, or a deletion that has not finished - and it
// reports nothing while it waits. An offline shift completion that hit this simply never returned:
// the button spun forever with no error anywhere. A rejection at least tells the crew what happened.
export class TimedOutError extends Error {
  constructor(what: string, ms: number) {
    super(`${what} did not finish within ${Math.round(ms / 1000)} seconds`)
    this.name = 'TimedOutError'
  }
}

export function withTimeout<T>(work: Promise<T>, what: string, ms = 15000): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new TimedOutError(what, ms)), ms)
    work.then(
      value => { clearTimeout(timer); resolve(value) },
      error => { clearTimeout(timer); reject(error) },
    )
  })
}
